module.exports = __webpack_public_path__ + "img/ab82e36.png";